import { render, staticRenderFns } from "./potensiWilayah.vue?vue&type=template&id=36f4cc60&"
import script from "./potensiWilayah.vue?vue&type=script&lang=js&"
export * from "./potensiWilayah.vue?vue&type=script&lang=js&"
import style0 from "./potensiWilayah.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QMarkupTable,QPagination,QDialog,QCard,QCardSection,QCardActions,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QMarkupTable,QPagination,QDialog,QCard,QCardSection,QCardActions,QBtn})
